
export const SET_CONTRACT_PARTIE_LOG = "SET_CONTRACT_PARTIE_LOG";
export function action_updateElementLog(logs) {
	return { type: SET_CONTRACT_PARTIE_LOG, payload: logs };
}

export const SET_CONTRACT_PARTIE_PRESENTATION = "SET_CONTRACT_PARTIE_PRESENTATION";
export function action_updateContractPresentation(presentation) {
	return { type: SET_CONTRACT_PARTIE_PRESENTATION, payload: presentation };
}

export const SET_CONTRACT_PARTIE_LIST = "SET_CONTRACT_PARTIE_LIST";
export function action_updateContractPartieList(contractPartieList) {
	return { type: SET_CONTRACT_PARTIE_LIST, payload: contractPartieList };
}

export const SET_CONTRACT_PARTIE_ITEM = "SET_CONTRACT_PARTIE_ITEM";
export function action_updateContractPartieItem(contractPartie) {
	return { type: SET_CONTRACT_PARTIE_ITEM, payload: contractPartie };
}

export const ADD_CONTRACT_PARTIE_ITEM = "ADD_CONTRACT_PARTIE_ITEM";
export function action_addContractPartieItem(contractPartie) {
	return { type: ADD_CONTRACT_PARTIE_ITEM, payload: contractPartie };
}

export const SET_CONTRACT_PARTIE_SUBITEM = "SET_CONTRACT_PARTIE_SUBITEM";
export function action_updateContractSubPartieItem(partieId, contractSubPartie) {
	return { type: SET_CONTRACT_PARTIE_SUBITEM, payload: { partieId, contractSubPartie } };
}

export const ADD_CONTRACT_PARTIE_SUBITEM = "ADD_CONTRACT_PARTIE_SUBITEM";
export function action_addContractSubPartieSubItem(partieId, contractSubPartie) {
	return { type: ADD_CONTRACT_PARTIE_SUBITEM, payload: {partieId, contractSubPartie} };
}

export const SET_CONTRACT_PARTIE_SELECTED = "SET_CONTRACT_PARTIE_SELECTED";
export function action_updateContractPartieSelected(contractPartie) {
	return { type: SET_CONTRACT_PARTIE_SELECTED, payload: contractPartie };
}
export const SET_CONTRACT_PARTIE_SELECTED_ID = "SET_CONTRACT_PARTIE_SELECTED_ID";
export function action_updateContractPartieSelectedId(contractPartieId) {
	return { type: SET_CONTRACT_PARTIE_SELECTED_ID, payload: contractPartieId };
}

export const SET_CONTRACT_SUBPARTIE_SELECTED = "SET_CONTRACT_SUBPARTIE_SELECTED";
export function action_updateContractSubPartieSelected(contractPartie) {
	return { type: SET_CONTRACT_SUBPARTIE_SELECTED, payload: contractPartie };
}
export const SET_CONTRACT_SUBPARTIE_SELECTED_ID = "SET_CONTRACT_SUBPARTIE_SELECTED_ID";
export function action_updateContractSubPartieSelectedId(contractSubPartieId) {
	return { type: SET_CONTRACT_SUBPARTIE_SELECTED_ID, payload: contractSubPartieId };
}

export const SET_FIRST_LOAD = "SET_FIRST_LOAD";
export function action_updateFirstLoad(isFirstLoad) {
	return { type: SET_FIRST_LOAD, payload: isFirstLoad };
}

export const SET_GENERAL_MESSAGE = "SET_GENERAL_MESSAGE";
export function action_updateGeneralMessage(message, show) {
	return { type: SET_GENERAL_MESSAGE, payload: { message, show } };
}

export const SET_CONTRACT_PARTIE_MESSAGE_LIST = "SET_CONTRACT_PARTIE_MESSAGE_LIST";
export function action_updateContractPartieMessageList(list) {
	return { type: SET_CONTRACT_PARTIE_MESSAGE_LIST, payload: list };
}

export const SET_CONTRACT_PARTIE_MESSAGE_ITEM = "SET_CONTRACT_PARTIE_MESSAGE_ITEM";
export function action_update(message, contractPartieId) {
	return { type: SET_CONTRACT_PARTIE_MESSAGE_ITEM, payload: { message, contractPartieId} };
}

export const SET_CONTRACT_PARTIE_PANEL_ITEM_ISOPEN = "SET_CONTRACT_PARTIE_PANEL_ITEM_ISOPEN";
export function action_updateContractPartieSidePanelIsOpen(type, isOpen) {
	return { type: SET_CONTRACT_PARTIE_PANEL_ITEM_ISOPEN, payload: { type, isOpen } };
}

export const SET_CONTRACT_PARTIE_FORM_CONFIG = "SET_CONTRACT_PARTIE_FORM_CONFIG";
export function action_updateFormConfigPartie(config) {
	return { type: SET_CONTRACT_PARTIE_FORM_CONFIG, payload: config };
}

export const SET_CONTRACT_PARTIE_FORM_CONFIG_PARTIE_NUMBER = "SET_CONTRACT_PARTIE_FORM_CONFIG_PARTIE_NUMBER";
export function action_updateFormConfigPartieNumber(number) {
	return { type: SET_CONTRACT_PARTIE_FORM_CONFIG_PARTIE_NUMBER, payload: number };
}

export const SET_CONTRACT_SUBPARTIE_FORM_CONFIG = "SET_CONTRACT_SUBPARTIE_FORM_CONFIG";
export function action_updateFormConfigSubPartie(config) {
	return { type: SET_CONTRACT_SUBPARTIE_FORM_CONFIG, payload: config };
}

export const SET_CONTRACT_POLYNOMY_FORM_CONFIG = "SET_CONTRACT_POLYNOMY_FORM_CONFIG";
export function action_updateFormConfigPolynomy(config) {
	return { type: SET_CONTRACT_POLYNOMY_FORM_CONFIG, payload: config };
}





export const ADD_PARTIE_POLINOMY = "ADD_PARTIE_POLINOMY";
export function action_addPartiePolinomy(partieId, polinomio) {
	return { type: ADD_PARTIE_POLINOMY, payload: {polinomio, partieId} };
}

export const ADD_SUBPARTIE_POLINOMY = "ADD_SUBPARTIE_POLINOMY";
export function action_addSubPartiePolinomy(subPartieId, polinomio) {
	return { type: ADD_SUBPARTIE_POLINOMY, payload: {polinomio, subPartieId} };
}

export const SET_PARTIE_POLINOMY = "SET_PARTIE_POLINOMY";
export function action_updatePartiePolinomy(partieId, polinomio) {
	return { type: SET_PARTIE_POLINOMY, payload:  {polinomio, partieId} };
}